// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__3Jzjc","bgWrapper":"styles_bgWrapper__3c3l1"};